import React from 'react';

import usePermissions from '../hooks/usePermissions';
import useEditorPermissions from '../hooks/useEditorPermissions';

import VideosAdminPermissions from '../components/videosAdminPermissions';
import useVideoVersion from '../hooks/useVideoVersion';

const VideosAdminPermissionsContainer = ({ isTopicPermissions }) => {
  const { videoVersion } = useVideoVersion({ isEnabled: false });
  const { editorPermissions } = useEditorPermissions();
  const { permissions, permissionsKey } = usePermissions({
    editorPermissions,
    isTopicsRoute: isTopicPermissions,
    videoVersion,
  });

  const schemaModules = ['editor', 'learner'];

  return (
    <VideosAdminPermissions
      schemaModules={schemaModules}
      isTopicPermissions={isTopicPermissions}
      permissions={permissions}
      permissionsKey={permissionsKey}
    />
  );
};

export default VideosAdminPermissionsContainer;
